/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ItsmeSignSessionDto } from '../model/itsmeSignSessionDto';
import { ItsmeSignatureDto } from '../model/itsmeSignatureDto';
import { ItsmeUserSessionDto } from '../model/itsmeUserSessionDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ItsmeSignatureService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Apply the signature
     * 
     * @param signerId Identifier of the signer
     * @param transactionId Identifier of the transaction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public itsmeApplySignature(signerId?: string, transactionId?: number, observe?: 'body', reportProgress?: boolean): Observable<ItsmeSignatureDto>;
    public itsmeApplySignature(signerId?: string, transactionId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItsmeSignatureDto>>;
    public itsmeApplySignature(signerId?: string, transactionId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItsmeSignatureDto>>;
    public itsmeApplySignature(signerId?: string, transactionId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (signerId !== undefined && signerId !== null) {
            queryParameters = queryParameters.set('signerId', <any>signerId);
        }
        if (transactionId !== undefined && transactionId !== null) {
            queryParameters = queryParameters.set('transactionId', <any>transactionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ItsmeSignatureDto>(`${this.basePath}/api/itsme/sign/apply`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the user identification status for itsme signature
     * 
     * @param lang Language of the user
     * @param redirectUrl URL on which the user will be redirected when proceeding the user identification
     * @param signerId Identifier of the signer
     * @param transactionId Identifier of the transaction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public itsmeSignSession(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe?: 'body', reportProgress?: boolean): Observable<ItsmeSignSessionDto>;
    public itsmeSignSession(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItsmeSignSessionDto>>;
    public itsmeSignSession(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItsmeSignSessionDto>>;
    public itsmeSignSession(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }
        if (redirectUrl !== undefined && redirectUrl !== null) {
            queryParameters = queryParameters.set('redirectUrl', <any>redirectUrl);
        }
        if (signerId !== undefined && signerId !== null) {
            queryParameters = queryParameters.set('signerId', <any>signerId);
        }
        if (transactionId !== undefined && transactionId !== null) {
            queryParameters = queryParameters.set('transactionId', <any>transactionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ItsmeSignSessionDto>(`${this.basePath}/api/itsme/sign/session`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the user identification for itsme signature
     * 
     * @param lang Language of the user
     * @param redirectUrl URL on which the user will be redirected when proceeding the user identification
     * @param signerId Identifier of the signer
     * @param transactionId Identifier of the transaction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public itsmeUserIdentification(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe?: 'body', reportProgress?: boolean): Observable<ItsmeUserSessionDto>;
    public itsmeUserIdentification(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItsmeUserSessionDto>>;
    public itsmeUserIdentification(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItsmeUserSessionDto>>;
    public itsmeUserIdentification(lang?: string, redirectUrl?: string, signerId?: string, transactionId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }
        if (redirectUrl !== undefined && redirectUrl !== null) {
            queryParameters = queryParameters.set('redirectUrl', <any>redirectUrl);
        }
        if (signerId !== undefined && signerId !== null) {
            queryParameters = queryParameters.set('signerId', <any>signerId);
        }
        if (transactionId !== undefined && transactionId !== null) {
            queryParameters = queryParameters.set('transactionId', <any>transactionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ItsmeUserSessionDto>(`${this.basePath}/api/itsme/sign/identification`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
